import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import {BatchHdrModel} from '../../../../../models/aggregates/erp/stock/batch-hdr.model';
import { ApiResponseModel, ApiVisa } from '../shared';


@Injectable({
  providedIn: 'root'
})

export class TraceBatchNumberService extends BaseApiTemplateService<BatchHdrModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/trace-batch-number/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/trace-batch-number/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/trace-batch-number/backoffice-ep';
    this.httpClient = http;
  }
}


